// extracted by mini-css-extract-plugin
module.exports = {"container":"MidiMenu_container__Uk9YD","shimmer":"MidiMenu_shimmer__Oozvd"};